module.exports = __webpack_public_path__ + "img/sorry.2d338c91.gif";